// Browser-safe: the contract imports this, so no node: or database imports.

import type { AddFields } from '../add-fields.ts';
import type { Setup } from './setup.ts';

export const DRAFT_SOURCES = ['TELEGRAM', 'TRADINGVIEW'] as const;

export type DraftProposal =
  /**
   * `newBook` is a book the post named that doesn't exist yet; a book is never
   * opened on the model's word alone, so the admin decides.
   */
  | {
      kind: 'add';
      fields: AddFields;
      books: string[];
      newBook: string | null;
      asksBook: boolean;
      /** The setup that fired it, which later firings match; absent on a post's. */
      setup?: Setup | null;
    }
  /** Null leaves that level unchanged. */
  | {
      kind: 'revise';
      recommendationId: number;
      targetPrice: number | null;
      stoplossPrice: number | null;
    }
  /** Null price closes at market. */
  | { kind: 'close'; recommendationId: number; price: number | null };
